// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"178":"Datepicker","265":"Player"}[chunkId] || chunkId) + "." + {"89":"b78650c1","178":"e5703c94","265":"fec0e62c"}[chunkId] + ".chunk.js";
};